import React, { useState, useRef, useEffect } from 'react';

export default ({
  maxLines = 5,
  lineHeight = 24,     // in px
  className = '',
  style = {},
  onChange,
  ...rest              // any other textarea attributes
}) => {
  const [value, setValue] = useState(
    rest.defaultValue ?? rest.value ?? ''
  );
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    // Reset height so scrollHeight is measured correctly
    el.style.height = 'auto';

    let paddingTop = 0;
    let paddingBottom = 0;

    if (typeof window !== 'undefined') {
      const computed = window.getComputedStyle(el);
      paddingTop = parseFloat(computed.paddingTop) || 0;
      paddingBottom = parseFloat(computed.paddingBottom) || 0;
    }

    // scrollHeight already includes padding
    const contentHeight = el.scrollHeight - paddingTop - paddingBottom;

    // Max content height for N lines
    const maxContentHeight = lineHeight * maxLines;

    const newContentHeight = Math.min(contentHeight, maxContentHeight);
    const newHeight = newContentHeight + paddingTop + paddingBottom + 2;

    el.style.height = `${newHeight}px`;
  }, [value, maxLines, lineHeight]);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) onChange(e); // still call caller's onChange
  };

  return (
    <textarea
      {...rest}
      ref={ref}
      rows={1}
      onChange={handleChange}
      className={`form-control ${className}`.trim()}
      style={{
        ...style,
        overflow: "auto",
        resize: "none",
        lineHeight: `${lineHeight}px`,
      }}
    />
  );
};
